import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Navbar } from 'react-bootstrap';
import { isLoggedIn } from '../utils';
import { logout } from '../actions';

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.onLogoutClick = this.onLogoutClick.bind(this);
    this.state = {
      adminPopoverActive: false,
    };
    this.toggleAdminPopover = this.toggleAdminPopover.bind(this);
  }

  onLogoutClick() {
    const { logout } = this.props;
    logout();
    browserHistory.push('/login/');
  }

  toggleAdminPopover() {
    const { adminPopoverActive } = this.state;
    this.setState({
      adminPopoverActive: !adminPopoverActive,
    });
  }

  render() {
    const { profile } = this.props;

    return (
      <Navbar>
        <div className="navbar-logo">
          <img alt="logo" className="fit-height" src="/assets/img/icons/logo.png" />
        </div>
        <div className="navbar-list">
          <div className="navbar-list-caption">Manage Content</div>
          <Link
            to="/entries/blitz"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Blitz Entries</Link>
          <Link
            to="/entries/external"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >External Content</Link>
          <Link
            to="/entries/scheduled"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Scheduled Entries</Link>
          <Link
            to="/pushnotifications/create/"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Push Notifications</Link>
          <Link
            to="/betausers/"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Beta Users</Link>
          <Link
            to="/tracking/"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Blitz App Tracking</Link>
          <Link
            to="/trackingfilter/"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Blitz App Filter</Link>
          <Link
            to="/trackingusers/"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Blitz Tracking Users</Link>
          <Link
            to="/championtips/"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Blitz Champion Tips</Link>
          <Link
            to="/blitzalert/"
            className="navbar-list-item"
            activeClassName="navbar-list-active"
          >Blitz Alert</Link>
        </div>
        {profile &&
          <div className="navbar-list">
            <div className="navbar-list-caption">Admin Tools</div>
            <Link to="/sources" className="navbar-list-item" activeClassName="navbar-list-active">Sources</Link>
            <Link to="/chatrooms" className="navbar-list-item" activeClassName="navbar-list-active">Chatrooms</Link>
            <Link to="/users" className="navbar-list-item" activeClassName="navbar-list-active">Users</Link>
          </div>
        }
        <div className="navbar-logout" onClick={this.onLogoutClick}>Logout</div>
      </Navbar>
    );
  }
}

SideBar.propTypes = {
  logout: PropTypes.func,
  profile: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    profile: state.user.profile,
    isLoggedIn: isLoggedIn(state),
  };
}

export default connect(
  mapStateToProps,
  { logout },
)(SideBar);



// WEBPACK FOOTER //
// ./src/cms/SideBar.js